<template>
  <div class="hello" style="background: #e4e4e4;height:100%">
    <header class="helloWord" >
      <!--<a href="index.html" class="backlastpage"></a>-->
       <div class="photoDiv">
        <div class="photo">
        <div class="headerPhoto">
          <img src="@/assets/img/title.jpg" alt="">
        </div>
        <div style="margin-left: 1rem">请设置昵称</div>
        </div>
        <p><van-icon name="arrow" /></p>
       </div>
      <div class="dynamic">
        <div class="dynamicDiv">
          <span >0</span>
          <span >收藏夹</span>
        </div>
        <div class="dynamicDiv">
          <span >0</span>
          <span >关注店铺</span>
        </div>
        <div class="dynamicDiv">
          <span>0</span>
          <span >足迹</span>
        </div>
        <div class="dynamicDiv">
          <span>{{couponNum}}</span>
          <span @click="toCard">红包卡卷</span>
        </div>
      </div>
      <!--<span class="positionHeaderS">推荐</span>-->
      <!--<van-icon name="scan" size="25" />-->
      <!--<van-icon name="setting" />-->
    </header>

    <div class="shopCenter">

        <div>
        <div class="editUser" @click="toAllOrder(0)">
          <div class="editUserLeft">
            <p style="" >我的订单</p>
            <!--<div v-else class="username" style="font-size: 20px;font-weight: 600">请完善个人资料</div>-->
            <!--<div v-else class="username" style="font-size: 15px;color: #f56723">请完善个人资料</div>-->


          </div>
          <div class="editUserRight" >
              <p style="color: #c1c0c0">查看全部订单</p>
               <p style="display: flex"><van-icon name="arrow" /></p>
          </div>
        </div>
          <div class="dynamic">
            <div class="dynamicDiv" @click="toAllOrder(1)">
              <span  ><van-icon name="star" color="#ff6400" size="25"/></span>
              <span >待付款</span>
            </div>
            <div class="dynamicDiv" @click="toAllOrder(2)">
              <span ><van-icon name="send-gift" color="#ff6400" size="25"/></span>
              <span >待发货</span>
            </div>
            <div class="dynamicDiv" @click="toAllOrder(3)">
              <span ><van-icon name="shopping-cart" color="#ff6400" size="25"/></span>
              <span >待收货</span>
            </div>
            <div class="dynamicDiv" @click="toAllOrder(4)">
              <span  ><van-icon name="chat" color="#ff6400" size="25"/></span>
              <span >待评价</span>
            </div>
          </div>
        </div>
      <!--<van-divider-->
        <!--:style="{ color: '#dedede', borderColor: '#dedede', padding: '0 16px',border: '16px' }"-->
      <!--&gt;-->
      <!--</van-divider>-->


      <div class="list">
        <!--<div class="qzzs">-->

        <ul class="listResume">

          <router-link to="/harvestAddress"><li><span class="listResumes1"><img src="@/assets/img/16.png" alt=""><span>地址管理</span></span><span class="listResumes2" ></span></li></router-link>
          <router-link to="/changePassWord"><li><span class="listResumes1" ><img src="@/assets/img/17.png" alt=""><span>账号安全</span></span>
            <span class="listResumes2" >修改登录密码</span>
          </li></router-link>
          <!--<router-link to="/setPassWord"><li><span class="listResumes1"><img src="@/assets/img/18.png" alt=""><span>设置密码</span></span><span class="listResumes2" ></span></li></router-link>-->
          <router-link to="/buyCoupons"><li><span class="listResumes1"><img src="@/assets/img/19.png" alt=""><span>购买现金券</span></span><span class="listResumes2" ></span></li></router-link>
          <li><span class="listResumes1"><img src="@/assets/img/19.png" alt=""><span>关于我们</span></span><span class="listResumes2" ></span></li>

        </ul>
        <!--<ul class="listResume">-->
          <!--<li @click="toHome"><span class="listResumes1"><span>切换身份</span></span><span class="listResumes2" >切换至我要招人才</span></li>-->
          <!--<router-link to="/changePassWord"><li><span class="listResumes1"><span>账号安全</span></span><span class="listResumes2" >修改登录密码</span></li></router-link>-->
          <!--<router-link to="/setPassWord"><li><span class="listResumes1"><span>设置密码</span></span><span class="listResumes2" ></span></li></router-link>-->
          <!--<li><span class="listResumes1"><span>关于我们</span></span><span class="listResumes2" ></span></li>-->
        <!--</ul>-->
      </div>

    </div>
    <div href="javascript:;" class="exitLogin" v-on:click="go">退出登录</div>
    <div class="go">
      <img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">
    </div>
    <van-tabbar route  active-color="#ff2500">
      <van-tabbar-item replace to="/home" icon="wap-home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/homeClass" icon="wap-home-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/newShop" icon="wap-home-o">
        购物车
      </van-tabbar-item>

      <van-tabbar-item replace to="/myShop" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  import pic from '@/assets/img/vip.png'
  import  popover  from 'vant';
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;

  export default {
    name: 'HelloWorld',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        list:{
          name:''
        },
        style:{
          backgroundImage:`url(${pic})`
        },
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        couponNum:0
      }
    },
    mounted(){
//      this.onLoad()
      this.userCouponNumber()
    },
    created () {
      interval = setInterval(() =>{
        let icnow = new Date();
        this.year = icnow.getFullYear();
        this.month = icnow.getMonth() + 1;
        this.date = icnow.getDate();
        this.day = days[icnow.getDay()];
        this.time = icnow.toTimeString().substring(0, 8);
      }, 1000)
    },
    computed: {
      // 当前时间
      newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
        return this.month + '月' + this.date + '日' + this.time;
      }
    },
    methods:{
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      toAllOrder(id){
        if(id==0){
          this.$router.push("/allOrder")
        }else {
          this.$router.push({
            path:"/allOrder",
            query:{
              id:id
            }
          })
        }
//
      },
      toCard(){
        this.$router.push("/cardRoll")
      },
      toHome(){
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,

        });
        setTimeout(() => {
          this.$router.push("/comMy")
        }, 2000);
      },
      go(){
        localStorage.removeItem('userid')
        window.location.href="https://m.shangshebao.com/account/login.html?type=shop"
//        this.$router.push({ path:'/log'  })
      },
      tojobWanted(id){
        this.$router.push({
          path:"/jobWanted",
          query:{
            id:id
          }
        })
      },
      onLoad() {
        this.$api.obtainMy({'userid':localStorage.getItem("userid")})
          .then(res=>{
            this.list=res.data?res.data[0]:{}
          })
          .catch(err=>{

          })
      },
      userCouponNumber() {
        this.$api.userCouponNumber({'user_id':localStorage.getItem("userid")})
          .then(res=>{
            this.couponNum=res.data?res.data:0
          })
          .catch(err=>{

          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  /*@import '../assets/css/my1.css';*/
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
  }
  .go img{
     width: 60px;
     border: solid 2px #e4e4e4;
     border-radius: 100%;
   }
  .shopCenter div{
    background: #FFFFFF;
    border-radius: 1rem;
    /*margin-top: 10px;*/
  }
  .shopCenter{
    font-size: 14px;
    padding: 190px 1rem;
  }
  .helloWord{
    width: 100%;
    /*height: 65px;*/
    background-color: #ff2500;
    position: fixed;
    top:0 ;

    color: #FFFFFF;
    z-index: 100;
     padding:1rem 0;
    border-radius: 10px;
  }
  .photoDiv{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1rem;
  }
  .photo{
    display: flex;
    align-items: center;
  }
  /*header img{*/
  /*width: 20px;*/
  /*height: 20px;*/
  /*}*/
  .headerPhoto{
    width: 50px;
    height: 50px;
    /*border-radius: 100%;*/
  }
  .headerPhoto img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
    /*padding-left: 10px;*/
  }
  .vipDivImg{
    width: 5rem;
    right: 34px;
    float: right;
    margin: 20px;
  }
  .dynamic{
    display: flex;
    justify-content: space-evenly;
    /*padding-bottom: 1rem;*/
    padding: 0.5rem 0;
    font-size: 13px;
  }
  .age{
    font-size: 13px;
  }
  .dynamicDiv{
    /*display: flex;*/
  }
  .dynamicDiv span{
    display: block;
    text-align: center;
  }
  .vipDiv{
    width: 90%;
    margin: auto;
    height: 4rem;
    /*background-image:url("../assets/img/vip.png");*/
    /*background-color: #fff;*/
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .vipDiv img{
    width: 100%;
    height: 100%;
  }
  .editUser{
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    /*padding-top: 15px;*/
  }
  .editUserRight img{
    width: 100%;
    border-radius: 100%;

  }
  .editUserRight{
    display: flex;
    align-items: center;
  }
  .editUserLeft img{
    width: 20px;
    height: 20px;
  }
  .jobList{

  }
  .listjl{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: left;*/
    /*margin-top: 16px;*/
    /*margin-left: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listjz{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: right;*/
    /*margin-top: 16px;*/
    /*margin-right: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listResume{
    line-height: 44px;
    margin-top: 10px;
    padding: 0 6px;
    font-size: 14px;
  }
  .listResume img {
    width: 20px;
    height:20px;
    padding-right: 10px;
  }
  .listResume li{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .listResumes2{
    font-size: 12px;
    color: #c1c0c0;
  }
  .listResumes1{
    /*font-size: 15px;*/
    display: flex;
    align-items: center;
  }
  .exitLogin{
    display: block;
    width: 100%;
    line-height: 40px;
    text-align: center;
    color: red;
    background-color: #fff;
    /*margin-bottom: 50px;*/
    position: fixed;
    bottom: 50px;
  }
  .list{
    margin-top: 30px;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/myShop.vue